import * as _ from 'underscore'

import { Enums } from "../common/enums"
import { OpDataList } from '../util'

import { IOpChangeState } from "../util/interfaces"
import { OpTransmissionDriverData } from './op-transmission-driver-data'
import { OpTransmissionDriverType } from './op-transmission-driver-type'


export class OpTransmissionDriver implements IOpChangeState {

    //#region Properties

    public idTransmissionDriver: number
    public idTransmissionDriverType: number
    public name: string
    public runAtHost: string
    public responceAddress: string
    public plugin: string
    public isActive: boolean
    public useCache: boolean

    //#endregion


    //#region Navigation properties

    public set transmissionDriverType(value: OpTransmissionDriverType) {
        this._transmissionDriverType = value

        if (value != null) {
            this.idTransmissionDriverType = value.idTransmissionDriverType
        }
    }
    public get transmissionDriverType(): OpTransmissionDriverType { return this._transmissionDriverType }
    private _transmissionDriverType: OpTransmissionDriverType

    //#endregion

    //#region Custom properties

    public opState: Enums.OpChangeState
    public dataList: OpDataList<OpTransmissionDriverData>
    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion    

    public toString(): string {
        return this.name
    }


    //#region IJsonSerializer Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idTransmissionDriver = opObj.ID_TRANSMISSION_DRIVER
            this.idTransmissionDriverType = opObj.ID_TRANSMISSION_DRIVER_TYPE
            this.name = opObj.NAME
            this.runAtHost = opObj.RUN_AT_HOST
            this.responceAddress = opObj.RESPONSE_ADDRESS
            this.plugin = opObj.PLUGIN
            this.isActive = opObj.IS_ACTIVE
            this.useCache = opObj.USE_CACHE

            this.transmissionDriverType = opObj._TransmissionDriverType != null ? new OpTransmissionDriverType(opObj._TransmissionDriverType) : null
            this.dataList = new OpDataList<OpTransmissionDriverData>(opObj.DataList)

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_TRANSMISSION_DRIVER: this.idTransmissionDriver,
            ID_TRANSMISSION_DRIVER_TYPE: this.idTransmissionDriverType,
            NAME: this.name,
            RUN_AT_HOST: this.runAtHost,
            RESPONSE_ADDRESS: this.responceAddress,
            PLUGIN: this.plugin,
            IS_ACTIVE: this.isActive,
            USE_CACHE: this.useCache,
            _TransmissionDriverType: this.transmissionDriverType != null ? this.transmissionDriverType.toJSON() : null
        }
    }

    //#endregion

    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpTransmissionDriver {
        const driver: OpTransmissionDriver = new OpTransmissionDriver(null)

        driver.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return driver
    }

    public copy(source: OpTransmissionDriver, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        if (includeNavigationProperties) {
            if (source.transmissionDriverType != null) {
                const newTransmissionDriverType: OpTransmissionDriverType = new OpTransmissionDriverType(null)
                newTransmissionDriverType.copy(source.transmissionDriverType, true, true)
                this.transmissionDriverType = newTransmissionDriverType
            }
        }

        if (includeCustomProperties) {

        }

        if (includeDataList) {
            if (source.dataList != null) {
                this.dataList = source.dataList.clone(true, true, true, true)
            }
        }

        if (includeDynamicValues) {
            //no dynamic values
        }

        this.idTransmissionDriver = source.idTransmissionDriver
        this.idTransmissionDriverType = source.idTransmissionDriverType
        this.name = source.name
        this.runAtHost = source.runAtHost
        this.responceAddress = source.responceAddress
        this.plugin = source.plugin
        this.isActive = source.isActive
        this.useCache = source.useCache

        this.opState = source.opState
    }

    //#endregion

}